import { render } from "./UserNoticeList.vue?vue&type=template&id=871fb0b6"
import script from "./UserNoticeList.vue?vue&type=script&lang=js"
export * from "./UserNoticeList.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/kokoroduke-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__